import $ from 'jquery';
import Swiper from 'swiper/bundle';

const wrapper = $('.players-action-block-action');
const number = wrapper.find('.players-action-block-number');
const image = wrapper.find('.players-action-block-image img');
const name = wrapper.find('.players-action-block-name');
const pos = wrapper.find('.players-action-block-position');
const button = wrapper.find('.players-action-block-button');

new Swiper('.players-action-block-slider', {
    slidesPerView: 'auto',
    spaceBetween: 30,
    initialSlide: 1,
    slideToClickedSlide: true,
    loop: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    navigation: {
        nextEl: '.players-action-block-next',
        prevEl: '.players-action-block-prev',
    },
    on: {
        slideChangeTransitionStart: function (instance) {
            const current = instance.slides[instance.activeIndex];
            const $current = $(current);
            const args = JSON.parse(
                $current.find('.feed-player').attr('data-args')
            );
            number.html(args.number);
            name.html(args.name.replace(/(\S+)\s*$/, '<span>$1</span>'));
            button.attr({
                href: args.url,
                title: args.name,
            });
            args.image ? image.attr('src', args.image) : '';
            pos.html('');
            args.pos.map((e) => {
                pos.append(`<a href="${e.url}">${e.name}</a>`);
            });
        },
    },
});
